import React from 'react';
import { SHORT_ANSWERS } from '../data/shortAnswers';

// "The short answer" box: the post's main question as a heading with a plain
// answer directly under it. Renders nothing for posts without an entry.
export default function ShortAnswer({ slug }) {
  const entry = SHORT_ANSWERS[slug];
  if (!entry) return null;
  return (
    <section
      aria-labelledby="short-answer-question"
      className="mb-10 rounded-xl border-l-4 border-cyan-500 bg-cyan-50 p-6"
      data-testid="short-answer"
    >
      <p className="text-xs font-semibold uppercase tracking-wider text-cyan-700">The short answer</p>
      <h2 id="short-answer-question" className="mt-2 text-xl md:text-2xl font-bold text-slate-900">
        {entry.question}
      </h2>
      <div className="mt-3 space-y-3 text-base leading-relaxed text-slate-700">
        {entry.answer.map((para) => (
          <p key={para}>{para}</p>
        ))}
      </div>
    </section>
  );
}
